import React from "react";

const Stepper = ({ active, setActive }) => {
  return (
    <div className="progressTabs">
      <div className="progressbar"></div>
      <ul className="stepTabs">
        <li
          className={active === "addInfo" ? "active" : ""}
          onClick={() => setActive("addInfo")}
        >
          <span></span>
          <p>Add Info</p>
        </li>
        <li
          className={active === "upload" ? "active" : ""}
          onClick={() => setActive("upload")}
        >
          <span></span>
          <p>Upload</p>
        </li>
        <li
          className={active === "preview" ? "active" : ""}
          onClick={() => setActive("preview")}
        >
          <span></span>
          <p>Preview</p>
        </li>
      </ul>
    </div>
  );
};

export default Stepper;
